module.exports = __webpack_public_path__ + "img/symbol_1.5c341f0c.png";